import { toast } from 'react-toastify';

const ToastError = (text, time) => {
  return (
    toast.error(text, {
      position: "top-right",
      autoClose: time ? time : 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
      style: {
        top: '100px'
      }
    })
  )
}

export default ToastError;